import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UtilService {


  constructor(private router: Router) { }

  navigate(path: string) {
    const vm = this;
    vm.router.navigate([path]);
  }

  getMinFormat(value) {
    return { year: new Date(value).getFullYear(), month: new Date(value).getMonth() + 1, day: new Date(value).getDate() };
  }

}
